/**
 * 依視窗寬度回傳 Mixpanel Device 超級屬性的值。
 * @returns {'Mobile' | 'Pad' | 'PC'}
 */
export function getInitialDevice() {
  const w = window.innerWidth;
  if (w < 768) return 'Mobile';
  if (w <= 1024) return 'Pad';
  return 'PC';
}

export default getInitialDevice;
